import { createTheme } from '@mui/material/styles';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#00f0ff', // Electric cyan
        },
        secondary: {
            main: '#ff4081', // Vibrant pink
        },
        background: {
            default: '#0d1117', // Deep dark background
            paper: '#161b22', // Card/Accordion background
        },
        text: {
            primary: '#ffffff',
            secondary: '#9ba1b0',
        },
        error: {
            main: '#ff1744',
        },
        warning: {
            main: '#ff9100',
        },
        info: {
            main: '#00b0ff',
        },
        success: {
            main: '#00e676',
        },
    },
    typography: {
        fontFamily: "'Orbitron', 'Roboto Mono', monospace",
        button: {
            textTransform: 'none',
            fontWeight: 'bold',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    padding: '8px 16px',
                },
            },
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1f2633',
                    color: '#ffffff',
                    borderRadius: 8,
                    marginBottom: '8px',
                    '&::before': {
                        display: 'none',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    },
});

export { darkTheme };